module.exports = __webpack_public_path__ + "img/apple_appstore_badge.0ca6796a.jpg";